import { render } from "./Tillval.vue?vue&type=template&id=1108daea"
import script from "./Tillval.vue?vue&type=script&lang=js"
export * from "./Tillval.vue?vue&type=script&lang=js"

import exportComponent from "/Users/williamsandstrom/repos/web/ytopi/ytopi-configurator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__